import { defineStore } from "pinia";
import { ProfileService } from "@core/services/webmaster/ProfileService";
import {
  FinancesRequisites,
  WebmasterProfileRequisitesAddInput
} from "@core/store/types/webmaster/finances/modal/financeRequisites";
import { useStateUpdater } from "@/helpers/useStateUpdater";
import { PaymentSystemsListService } from "@core/services/common/lists/PaymentSystemsListService";

export const useRequisiteStore = defineStore("webmaster/requisiteStore", {
  state: (): FinancesRequisites => ({
    data: {},
    paymentSystems: {},
    input: {
      purse: null,
      paymentSystemId: null
    }
  }),

  getters: {
  },

  actions: {
    async VALIDATE_REQUISITE_BY_INTEGRATOR (integrator: string) {
      return await ProfileService.validateRequisite(integrator, this.input.purse);
    },

    async ADD_REQUISITE () {
      const item = await ProfileService.addRequisite(this.input as WebmasterProfileRequisitesAddInput);
      useStateUpdater(useRequisiteStore).LOCAL_ADD({ items: [item] });
    },

    async GET_REQUISITES () {
      const { data: { requisites } } = await ProfileService.getRequisites();
      this.data = requisites;
    },

    async GET_PAYMENT_SYSTEMS () {
      const { data: { paymentSystems: data } } = await PaymentSystemsListService.getPaymentSystems(
        {},
        50,
        0
      );

      this.paymentSystems = data;
    },

    async REMOVE_REQUISITE (requisiteId: string) {
      const item = await ProfileService.removeRequisite(requisiteId);
      useStateUpdater(useRequisiteStore).LOCAL_DELETE({ items: [item] });
    }
  }
});